import type { IntlShape } from 'react-intl'
import { SAVE_THOUSANDS_REGIONS } from 'luxPlus/constants/benefits'

/**
 * @param regionCode - current region code
 * @param intl - react-intl IntlShape for localisation
 * @returns save amount copy - depending on if the region has a high denomination currency such as ZAR, THB, etc.
 */
function getRegionSaveAmountCopy(regionCode: string, intl: IntlShape) {
  const isSaveThousandsRegion = SAVE_THOUSANDS_REGIONS.includes(regionCode)
  return isSaveThousandsRegion
    ? intl.formatMessage({
        id: 'pHMqUvu+GN',
        defaultMessage: 'thousands',
        description: 'Savings amount descriptor for high-denomination currency regions',
      })
    : intl.formatMessage({
        id: 'z1+tI+1zLx',
        defaultMessage: 'hundreds',
        description: 'Savings amount descriptor for standard currency regions',
      })
}

export default getRegionSaveAmountCopy
